<template>
  <v-container fluid>
    <v-layout row>
      <v-flex>
        <v-data-table
          :headers="headers"
          :items="workHistory"
          :pagination.sync="defaultSort"
          class="elevation-1"
        >
          <template slot="items" slot-scope="{ item }">
              <tr @click="openShift(item.id)" style="cursor: pointer;">
                <td>
                  {{ item.startDatetime | moment("MM/DD/YY") }}
                </td>
                <td>
                  {{ item.position }}
                </td>
                <td>
                  {{ item.location }}
                </td>
                <td>
                  {{ item.clientNotes | truncate(50) | placeholder('N/A') }}
                </td>
                <td class="todo">
                  {{ item.reviewStarCount | placeholder('N/A') }}
                </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  components: {
  },
  created: function() {
    this.$store.dispatch('hr/getWorkHistory', { user_id: this.employee.id })
  },
  props: [
    'employee'
  ],
  computed: {
    ...mapState('hr', [
      'workHistory',
      'workHistoryStats',
    ]),
  },
  data: function() {
    return {
      defaultSort: {
        sortBy: 'startDatetime',
        descending: true,
        rowsPerPage: -1,
      },
      headers: [
        {
          text: 'Date',
          value: 'startDatetime',
        },
        {
          text: 'Position',
          value: 'position',
        },
        {
          text: 'Location',
          value: 'location',
        },
        {
          text: 'Notes',
          value: 'notes'
        },
        {
          text: 'Rating',
          value: 'rating'
        },
      ],
    }
  },
  methods: {
    openShift (id) {
      this.$router.push({ name: 'shiftDetail', params: { shiftId: id } })
    }
  }

}
</script>

<style scoped>
  .selected {
  }
</style>
